import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import flatMapDeep from 'lodash.flatmapdeep';
import values from 'lodash.values';
import { createAction, createReducer, createCachedSelector, isTruthyQueryParameter, createSelector, outOfDateStatus, upToDateStatus } from '@techstyle/redux-core';
import { ProductsPage } from './schema';
export var initialState = {
  breadcrumbs: {
    categoryIds: {}
  },
  // FIXME: SXF already has a state/reducer named `products`, so we have to
  // avoid clobbering that. Come up with a better name, or make compatible with
  // SXF in the future?
  productsMeta: {
    debugEs: false
  },
  byo: {
    configs: {},
    networkStatus: outOfDateStatus()
  }
};
export var setDebugEs = createAction('products/setDebugEs');
export var loadCategoryBreadcrumbsRequest = createAction('products/loadCategoryBreadcrumbsRequest');
export var loadCategoryBreadcrumbsSuccess = createAction('products/loadCategoryBreadcrumbsSuccess');
export var loadCategoryBreadcrumbsFailure = createAction('products/loadCategoryBreadcrumbsFailure');
export var loadProductsRequest = createAction('products/loadProductsRequest');
export var loadProductsSuccess = createAction('products/loadProductsSuccess');
export var loadProductsFailure = createAction('products/loadProductsFailure');
export var loadProductsByIdsRequest = createAction('products/loadProductsByIdsRequest');
export var loadProductsByIdsSuccess = createAction('products/loadProductsByIdsSuccess');
export var loadProductsByIdsFailure = createAction('products/loadProductsByIdsFailure');
export var loadProductRequest = createAction('products/loadProductRequest');
export var loadProductSuccess = createAction('products/loadProductSuccess');
export var loadProductFailure = createAction('products/loadProductFailure');
export var loadProductBundleRequest = createAction('products/loadProductBundleRequest');
export var loadProductBundleSuccess = createAction('products/loadProductBundleSuccess');
export var loadProductBundleFailure = createAction('products/loadProductBundleFailure');
export var loadProductByPermalinkRequest = createAction('products/loadProductByPermalinkRequest');
export var loadProductByPermalinkSuccess = createAction('products/loadProductByPermalinkSuccess');
export var loadProductByPermalinkFailure = createAction('products/loadProductByPermalinkFailure');
export var loadRecommendedProductsRequest = createAction('products/loadRecommendedProductsRequest');
export var loadRecommendedProductsSuccess = createAction('products/loadRecommendedProductsSuccess');
export var loadRecommendedProductsFailure = createAction('products/loadRecommendedProductsFailure');
export var loadCustomerRecommendedProductsRequest = createAction('products/loadCustomerRecommendedProductsRequest');
export var loadCustomerRecommendedProductsSuccess = createAction('products/loadCustomerRecommendedProductsSuccess');
export var loadCustomerRecommendedProductsFailure = createAction('products/loadCustomerRecommendedProductsFailure');
export var loadRelatedProductsRequest = createAction('products/loadRelatedProductsRequest');
export var loadRelatedProductsSuccess = createAction('products/loadRelatedProductsSuccess');
export var loadRelatedProductsFailure = createAction('products/loadRelatedProductsFailure');
export var loadProductsByGeoLocationRequest = createAction('products/loadProductsByGeoLocationRequest');
export var loadProductsByGeoLocationSuccess = createAction('products/loadProductsByGeoLocationSuccess');
export var loadProductsByGeoLocationFailure = createAction('products/loadProductsByGeoLocationFailure');
export var loadSubcoItemsRequest = createAction('products/loadSubcoItemsRequest');
export var loadSubcoItemsSuccess = createAction('products/loadSubcoItemsSuccess');
export var loadSubcoItemsFailure = createAction('products/loadSubcoItemsFailure');
export var loadProductPersonalizationOptionsRequest = createAction('products/loadProductPersonalizationOptionsRequest');
export var loadProductPersonalizationOptionsSuccess = createAction('products/loadProductPersonalizationOptionsSuccess');
export var loadProductPersonalizationOptionsFailure = createAction('products/loadProductPersonalizationOptionsFailure');
export var loadCustomizationPreviewRequest = createAction('products/loadCustomizationPreviewRequest');
export var loadCustomizationPreviewSuccess = createAction('products/loadCustomizationPreviewSuccess');
export var loadCustomizationPreviewFailure = createAction('products/loadCustomizationPreviewFailure');
export var loadByoConfigRequest = createAction('products/loadByoConfigRequest');
export var loadByoConfigSuccess = createAction('products/loadByoConfigSuccess');
export var loadByoConfigFailure = createAction('products/loadByoConfigFailure');
export var trackProductClicked = createAction('products/trackProductClicked');
export var trackProductListViewed = createAction('products/trackProductListViewed');
export var trackProductViewed = createAction('products/trackProductViewed');
export var trackProductDetailViewed = createAction('products/trackProductDetailViewed');
export var trackProductDetailImageViewed = createAction('products/trackProductDetailImageViewed');
export var trackProductPriceViewed = createAction('products/trackProductPriceViewed');
export function initProducts() {
  return function (dispatch, getState, context) {
    if (context.isServer && !context.hasPreloadedState) {
      var debugEs = context.req.query.debugEs;

      if (isTruthyQueryParameter(debugEs)) {
        dispatch(setDebugEs(true));
      }
    }
  };
}
export function loadProducts(payload) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState, context) {
    var _options$apiVersion = options.apiVersion,
        apiVersion = _options$apiVersion === void 0 ? 1 : _options$apiVersion,
        productSource = options.productSource;
    var endpoint = apiVersion >= 2 ? "products/v".concat(apiVersion) : 'products';
    var headers = {};

    if (productSource) {
      headers.psrc = productSource;
    }

    var debugEs = getState().productsMeta.debugEs;

    if (debugEs) {
      payload = _objectSpread({
        debugEs: true,
        debugTier1: true,
        debugBento: true
      }, payload);
    }

    return dispatch({
      bentoApi: {
        endpoint: endpoint,
        headers: headers,
        json: payload,
        method: 'POST',
        requestKey: "loadProducts:".concat(JSON.stringify([endpoint, payload])),
        schema: ProductsPage,
        actions: [loadProductsRequest, loadProductsSuccess, loadProductsFailure]
      }
    });
  };
}
export function loadProductsByIds(_ref) {
  var masterProductIds = _ref.masterProductIds,
      options = _objectWithoutProperties(_ref, ["masterProductIds"]);

  if (Array.isArray(masterProductIds) && masterProductIds.length) {
    return {
      bentoApi: {
        endpoint: "products/multiple",
        searchParams: {
          masterProductIds: masterProductIds.join(',')
        },
        // TODO: schema!
        actions: [loadProductsByIdsRequest, loadProductsByIdsSuccess, loadProductsByIdsFailure]
      }
    };
  }
}
export function loadProduct(masterProductId) {
  return {
    bentoApi: {
      endpoint: "products/".concat(parseInt(masterProductId)),
      // TODO: schema!
      actions: [loadProductRequest, loadProductSuccess, loadProductFailure]
    }
  };
}
export function loadProductBundle(masterProductId) {
  return {
    bentoApi: {
      endpoint: "products/sets/".concat(parseInt(masterProductId)),
      // TODO: schema!
      actions: [loadProductBundleRequest, loadProductBundleSuccess, loadProductBundleFailure]
    }
  };
}
export function loadProductByPermalink(permalink) {
  return {
    bentoApi: {
      endpoint: "products/permalink/".concat(permalink),
      // TODO: schema!
      actions: [loadProductByPermalinkRequest, loadProductByPermalinkSuccess, loadProductByPermalinkFailure]
    }
  };
}
export var loadCategoryBreadcrumbs = function loadCategoryBreadcrumbs(categoryId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!categoryId) {
    throw new Error("loadCategoryBreadcrumbs must be called with a categoryId");
  }

  return {
    bentoApi: {
      endpoint: "categories/".concat(categoryId, "/breadcrumbs"),
      sessionRequired: false,
      requestKey: JSON.stringify(['breadcrumbs', categoryId]),
      actions: [loadCategoryBreadcrumbsRequest, function (payload, meta) {
        return loadCategoryBreadcrumbsSuccess(payload, _objectSpread(_objectSpread({}, meta), {}, {
          categoryId: categoryId
        }));
      }, loadCategoryBreadcrumbsFailure]
    }
  };
};
export function loadRecommendedProducts(masterProductId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$algorithm = options.algorithm,
      algorithm = _options$algorithm === void 0 ? 'ymal' : _options$algorithm,
      _options$size = options.size,
      size = _options$size === void 0 ? 15 : _options$size,
      _options$retailDiscou = options.retailDiscounting,
      retailDiscounting = _options$retailDiscou === void 0 ? false : _options$retailDiscou,
      _options$filterProduc = options.filterProductTagIds,
      filterProductTagIds = _options$filterProduc === void 0 ? [] : _options$filterProduc,
      params = options.params;
  return {
    bentoApi: {
      endpoint: "products/v2/".concat(parseInt(masterProductId), "/recommended"),
      searchParams: _objectSpread({
        algorithm: algorithm,
        size: size,
        retailDiscounting: retailDiscounting,
        filterProductTagIds: filterProductTagIds
      }, params),
      method: 'GET',
      requestKey: JSON.stringify(['loadRecommendedProducts', masterProductId, options]),
      schema: ProductsPage,
      actions: [loadRecommendedProductsRequest, loadRecommendedProductsSuccess, loadRecommendedProductsFailure]
    }
  };
}
export function loadCustomerRecommendedProducts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$algorithm2 = options.algorithm,
      algorithm = _options$algorithm2 === void 0 ? 'boutique' : _options$algorithm2,
      _options$page = options.page,
      page = _options$page === void 0 ? 1 : _options$page,
      _options$size2 = options.size,
      size = _options$size2 === void 0 ? 15 : _options$size2,
      _options$membershipBr = options.membershipBrandIds,
      membershipBrandIds = _options$membershipBr === void 0 ? [] : _options$membershipBr;
  return {
    bentoApi: {
      endpoint: "products/v2/customerRecommended",
      searchParams: {
        algorithm: algorithm,
        page: page,
        size: size,
        membershipBrandIds: membershipBrandIds
      },
      method: 'GET',
      requestKey: JSON.stringify(['loadCustomerRecommendedProducts', options]),
      schema: ProductsPage,
      actions: [loadCustomerRecommendedProductsRequest, loadCustomerRecommendedProductsSuccess, loadCustomerRecommendedProductsFailure]
    }
  };
}
export function loadRelatedProducts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$size3 = options.size,
      size = _options$size3 === void 0 ? 15 : _options$size3,
      _options$retailDiscou2 = options.retailDiscounting,
      retailDiscounting = _options$retailDiscou2 === void 0 ? false : _options$retailDiscou2;
  return {
    bentoApi: {
      endpoint: "products/relatedProducts",
      searchParams: {
        size: size,
        retailDiscounting: retailDiscounting
      },
      method: 'GET',
      requestKey: 'relatedProducts',
      schema: ProductsPage,
      actions: [loadRelatedProductsRequest, loadRelatedProductsSuccess, loadRelatedProductsFailure]
    }
  };
}
/* Get products using brand specific logic using geolocation implemented in BentoAPI. Works for JF and SD */

export function loadProductsByGeoLocation(options) {
  return function (dispatch, getState, context) {
    var zip = options.zip;

    var payload = _objectSpread({}, options);

    if (!zip) {
      payload.ipAddress = getState().intl.ipAddress;
    }

    return dispatch({
      bentoApi: {
        endpoint: "products/geolocation",
        json: payload,
        method: 'POST',
        requestKey: JSON.stringify(['productsByGeolocation', payload]),
        schema: ProductsPage,
        actions: [loadProductsByGeoLocationRequest, loadProductsByGeoLocationSuccess, loadProductsByGeoLocationFailure]
      }
    });
  };
}
export function loadSubcoItems() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    bentoApi: {
      endpoint: "products/subscriptions",
      method: 'GET',
      searchParams: params,
      requestKey: JSON.stringify(['getSubscriptionList', params]),
      actions: [loadSubcoItemsRequest, loadSubcoItemsSuccess, loadSubcoItemsFailure]
    }
  };
}
export function loadProductPersonalizationOptions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var masterProductId = params.masterProductId;
  return {
    bentoApi: {
      endpoint: "products/".concat(masterProductId, "/personalizations"),
      method: 'GET',
      searchParams: params,
      requestKey: JSON.stringify(['getProductPersonalizationOptions', params]),
      actions: [loadProductPersonalizationOptionsRequest, loadProductPersonalizationOptionsSuccess, loadProductPersonalizationOptionsFailure]
    }
  };
}
export function loadCustomizationPreview() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var masterProductId = params.masterProductId;
  return {
    bentoApi: {
      endpoint: "products/".concat(masterProductId, "/embroidery/preview"),
      method: 'GET',
      searchParams: params,
      requestKey: JSON.stringify(['getCustomizationPreview', params]),
      actions: [loadCustomizationPreviewRequest, loadCustomizationPreviewSuccess, loadCustomizationPreviewFailure]
    }
  };
}
/**
 * @function loadByoConfigs Retrieves Build Your Own bundle configs maintained in Console via `products/byo/config`
 * @param {Object} params Includes optional params for the query
 * @param {String} params.searchByDate The date in which we want to fetch configs by
 * @param {Boolean} params.filterInactiveConfigs Flag passed to filter out inactive products
 * @returns
 */

export var loadByoConfigs = function loadByoConfigs(_ref2) {
  var _ref2$params = _ref2.params,
      params = _ref2$params === void 0 ? {
    searchByDate: '',
    filterInactiveConfigs: false
  } : _ref2$params,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {
    includeFlattenedConfigs: false
  } : _ref2$options;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var networkStatus, includeFlattenedConfigs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              networkStatus = getState().byo.networkStatus;

              if (networkStatus.isUpToDate) {
                _context.next = 4;
                break;
              }

              includeFlattenedConfigs = options.includeFlattenedConfigs;
              return _context.abrupt("return", dispatch({
                bentoApi: {
                  endpoint: 'products/byo/config',
                  searchParams: params,
                  requestKey: JSON.stringify(['loadByoConfigs', params.searchByDate, params.filterInactiveConfigs]),
                  actions: [loadByoConfigRequest, function (payload, meta) {
                    return loadByoConfigSuccess(payload, _objectSpread(_objectSpread({}, meta), {}, {
                      includeFlattenedConfigs: includeFlattenedConfigs
                    }));
                  }, loadByoConfigFailure]
                }
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var breadcrumbsReducer = createReducer(initialState.breadcrumbs, _defineProperty({}, loadCategoryBreadcrumbsSuccess, function (state, action) {
  state.categoryIds[action.meta.categoryId] = action.payload;
}));
export var productsMetaReducer = createReducer(initialState.productsMeta, _defineProperty({}, setDebugEs, function (state, action) {
  state.debugEs = action.payload;
}));
export var byoReducer = createReducer(initialState.byo, _defineProperty({}, loadByoConfigSuccess, function (state, action) {
  action.payload.forEach(function (config) {
    state.configs[config.byoProductId] = config;
  });

  if (action.meta.includeFlattenedConfigs) {
    state.flattenedConfigs = flatMapDeep(state.configs, values).filter(function (config) {
      return config.byoConfig;
    });
  }

  state.networkStatus = upToDateStatus();
}));
var getCachedBreadcrumbDataForCategory = createCachedSelector([function (state, categoryId) {
  return state.breadcrumbs.categoryIds;
}, function (state, categoryId) {
  return categoryId;
}], function (breadcrumbs, categoryId) {
  if (!breadcrumbs[categoryId]) {
    return null;
  }

  return breadcrumbs[categoryId];
})(function (state, categoryId) {
  return categoryId;
});
export function getBreadcrumbDataForCategory(state, categoryId) {
  if (!categoryId) {
    return null;
  }

  return getCachedBreadcrumbDataForCategory(state, categoryId);
}
var getCachedCategoryBreadcrumbHierarchy = createCachedSelector([function (state, categoryId) {
  return state.breadcrumbs.categoryIds;
}, function (state, categoryId) {
  return categoryId;
}], function (breadcrumbs, categoryId) {
  if (!breadcrumbs[categoryId]) {
    return null;
  }

  var breadcrumbsForCategory = breadcrumbs[categoryId];
  return breadcrumbsForCategory.ancestors ? [].concat(_toConsumableArray(breadcrumbsForCategory.ancestors.slice().reverse()), [breadcrumbsForCategory]) : [breadcrumbsForCategory];
})(function (state, categoryId) {
  return categoryId;
});
export function getCategoryBreadcrumbHierarchy(state, categoryId) {
  if (!categoryId) {
    return null;
  }

  return getCachedCategoryBreadcrumbHierarchy(state, categoryId);
}
export var getByoConfigs = createSelector([function (state) {
  return state.byo;
}], function (byo) {
  return byo;
});
export default {
  id: 'products',
  reducerMap: {
    breadcrumbs: breadcrumbsReducer,
    productsMeta: productsMetaReducer,
    byo: byoReducer
  },
  initialActions: [initProducts()]
};